import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	filtro: {
		tituloOuAutor: {
			value: null,
			default: null,
			label: 'Autor ou Titulo',
		},
	},
	modalPenalidade: {
		idPenalidade: {
			value: null,
		},
	},
	exibirSincronizarAreaPublica: {
		desabilitarEnviar: false,
		desabilitarCancelar: false,
	},
	documentosSelecionados: [],
	isSelecionouTodosItensDaListaDeDocumentosAta: null,
	atualiza: 0,
	paginacao: paginacaoListagem('id', 5, 'ASC'),
}
